// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, signal } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { Observable } from 'rxjs';
import {
  NotaControlAbrasfResultado,
  NotaControlConsultarDpsDisponivelResultado,
  NotaControlGatewayService
} from '../../services/notacontrol-gateway.service';

/** Estado (carregando/resultado/erro) de uma consulta ABRASF individual na tela. */
interface EstadoAbrasf {
  carregando: ReturnType<typeof signal<boolean>>;
  resultado: ReturnType<typeof signal<NotaControlAbrasfResultado | null>>;
  erro: ReturnType<typeof signal<string>>;
  erroDetalhe: ReturnType<typeof signal<string>>;
}

function novoEstadoAbrasf(): EstadoAbrasf {
  return {
    carregando: signal(false),
    resultado: signal<NotaControlAbrasfResultado | null>(null),
    erro: signal(''),
    erroDetalhe: signal('')
  };
}

/**
 * Tela simples de teste da integracao Nota Control (NFS-e) -- so a Consulta
 * de DPS Disponivel por enquanto. Objetivo unico: confirmar que o backend
 * consegue se comunicar com o webservice (sem chute na tela, so mostra o
 * resultado ou o erro cru vindo do gateway).
 */
// @ts-ignore
@Component({
  selector: 'app-nota-control-teste',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './nota-control-teste.component.html',
  styleUrl: './nota-control-teste.component.css'
})
export class NotaControlTesteComponent {
  carregando = signal(false);
  pagina = signal(1);
  resultado = signal<NotaControlConsultarDpsDisponivelResultado | null>(null);
  erro = signal('');
  erroDetalhe = signal('');

  constructor(private readonly notaControlGateway: NotaControlGatewayService) {
  }

  consultar(): void {
    this.carregando.set(true);
    this.erro.set('');
    this.erroDetalhe.set('');
    this.resultado.set(null);

    this.notaControlGateway.consultarDpsDisponivel(this.pagina()).subscribe({
      next: (res) => {
        this.carregando.set(false);
        this.resultado.set(res);
      },
      error: (err: any) => {
        this.carregando.set(false);
        const problemDetail = err?.error;
        this.erro.set(problemDetail?.title || `Erro HTTP ${err?.status ?? ''}`.trim());
        this.erroDetalhe.set(problemDetail?.detail || err?.message || 'Falha de comunicacao.');
      }
    });
  }

  jsonResultado(): string {
    const res = this.resultado();
    return res ? JSON.stringify(res, null, 2) : '';
  }

  // ---- ABRASF 2.04 (producao, endpoint legado por municipio) ----

  // ConsultarNfseServicoPrestado
  spDataInicial = signal('');
  spDataFinal = signal('');
  spPagina = signal(1);
  estadoServicoPrestado = novoEstadoAbrasf();

  // ConsultarNfsePorRps
  rpsNumero = signal('');
  rpsSerie = signal('');
  rpsTipo = signal('1');
  estadoPorRps = novoEstadoAbrasf();

  // ConsultarNfsePorFaixa
  faixaInicial = signal('');
  faixaFinal = signal('');
  faixaPagina = signal(1);
  estadoPorFaixa = novoEstadoAbrasf();

  // ConsultarUrlNfse
  urlNumeroNfse = signal('');
  estadoUrlNfse = novoEstadoAbrasf();

  // ConsultarDadosCadastrais
  estadoDadosCadastrais = novoEstadoAbrasf();

  consultarServicoPrestado(): void {
    this.executarAbrasf(
      this.notaControlGateway.consultarNfseServicoPrestado(this.spDataInicial(), this.spDataFinal(), this.spPagina()),
      this.estadoServicoPrestado
    );
  }

  consultarPorRps(): void {
    this.executarAbrasf(
      this.notaControlGateway.consultarNfsePorRps(this.rpsNumero(), this.rpsSerie(), this.rpsTipo()),
      this.estadoPorRps
    );
  }

  consultarPorFaixa(): void {
    this.executarAbrasf(
      this.notaControlGateway.consultarNfsePorFaixa(this.faixaInicial(), this.faixaFinal(), this.faixaPagina()),
      this.estadoPorFaixa
    );
  }

  consultarUrlNfse(): void {
    this.executarAbrasf(
      this.notaControlGateway.consultarUrlNfse(this.urlNumeroNfse()),
      this.estadoUrlNfse
    );
  }

  consultarDadosCadastrais(): void {
    this.executarAbrasf(
      this.notaControlGateway.consultarDadosCadastrais(),
      this.estadoDadosCadastrais
    );
  }

  private executarAbrasf(obs: Observable<NotaControlAbrasfResultado>, estado: EstadoAbrasf): void {
    estado.carregando.set(true);
    estado.erro.set('');
    estado.erroDetalhe.set('');
    estado.resultado.set(null);

    obs.subscribe({
      next: (res) => {
        estado.carregando.set(false);
        estado.resultado.set(res);
      },
      error: (err: any) => {
        estado.carregando.set(false);
        const problemDetail = err?.error;
        estado.erro.set(problemDetail?.title || `Erro HTTP ${err?.status ?? ''}`.trim());
        estado.erroDetalhe.set(problemDetail?.detail || err?.message || 'Falha de comunicacao.');
      }
    });
  }
}
